import styled, { css } from "styled-components";
import { poppins } from "@/components/common/fonts";
import { Button, Upload, Input } from "antd";
import { Swiper, SwiperSlide } from "swiper/react";

export const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  min-width:1000px;
  background-color: #fafbfd;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PageDescription = styled.div`
  padding: 125px 0 30px;
  width:47%;
  font-family: ${poppins.string};

  h3 {
    margin: 0 0 10px;
    padding: 0;
    font-size: 32px;
    font-weight: 700;
    color: #000;
    text-align: center;
    line-height: 1.3;
  }
  p {
    min-height: 50px;
    margin: 0 auto;
    padding: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.25;
    color: #777;
    text-align: center;
    width:100%;
  }
`;

export const PageWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
`;


export const PageLoaderText = styled.p`
  margin: 0;
  font-family: ${poppins.string};
  font-size: 20px;
  font-weight: 400;
  color: #fff;
`;

export const HeaderContainer = styled.div`
  z-index: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 17px 150px;
  background-color: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(2px);
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.02),
    0 2px 2px 0 rgba(0, 0, 0, 0.02),
    0 4px 4px 0 rgba(0, 0, 0, 0.02),
    0 8px 8px 0 rgba(0, 0, 0, 0.02),
    0 16px 16px 0 rgba(0, 0, 0, 0.02);

  @media screen and (max-width: 768px) {
    padding: 17px 16px;
  }
`

export const HeaderButtonBack = styled(Button)`
  box-sizing: content-box;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  position: absolute;
  top: 50%;
  left: 50px;
  transform: translateY(-50%);
  padding: 8px 10px;
  font-family: ${poppins.string};
  font-size: 14px;
  font-weight: 500;
  color: #53677b;

  @media screen and (max-width: 1280px) {
    left: 10px;
  }
  @media screen and (max-width: 1110px) {
    gap: 0;

    .button-text {
      width: 1px !important;
      height: 1px !important;
      padding: 0 !important;
      margin: -1px !important;
      overflow: hidden !important;
      clip: rect(0, 0, 0, 0) !important;
      white-space: nowrap !important;
      border: 0 !important;
    }
  }
`

export const HeaderStepText = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  max-width: 780px;
  margin: 0 auto;
  padding: 0;
  text-align: center;
  width: 100%;
  list-style: none;
  gap: 70px;

  li {
    position: relative;
    font-family: ${poppins.string};
    font-size: 16px;
    font-weight: 600;
    color: #53677b;
    line-height: 22px;

    .number {
      overflow: hidden;
      position: relative;
      display: inline-block;
      width: 22px;
      height: 22px;
      margin-right: 12px;
      border-radius: 50%;
      text-align: center;
      font-size: 11px;
      background-color: #dbe2ea;
      vertical-align: middle;

      svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .text {
      position: relative;
      bottom: -2px;
    }
  }
  li.active {
    color: #4276ee;

    .number {
      color: #fff;
      background-color: #4276ee;
    }
  }
  @media screen and (max-width: 768px) {
    gap: 26px;

    li:not(.active) {
      padding-right: 20px;

      &::before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        width: 1px;
        height: 1px;
        border-radius: 100%;
        transform: translateY(-50%);
        box-shadow: -12px 12px 0 1px #53677b,
          -6px 12px 0 1px #53677b,
          0 12px 0 1px #53677b;
      }
      .text {
        display: inline-block;
        width: 1px !important;
        height: 1px !important;
        padding: 0 !important;
        margin: -1px !important;
        overflow: hidden !important;
        clip: rect(0, 0, 0, 0) !important;
        white-space: nowrap !important;
        border: 0 !important;
      }
    }
  }
`;

export const StepButtonWrapper = styled.div<{ $marginTop?: number; $paddingBottom?: number; }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 30px;
  margin-top: ${({ $marginTop }) => {
    if ($marginTop) {
      return `${$marginTop}px`;
    }
    return "70px";
  }};
  padding-bottom: ${({ $paddingBottom }) => {
    if($paddingBottom) {
      return `${$paddingBottom}px`;
    }
    return "100px";
  }};
`;

export const StepButton = styled(Button)`
  min-width: 268px;
  min-height: 48px;
  font-family: ${poppins.string};
  font-size: 14px;
  font-weight: 400;
`;

//CreateSeries Styles-------------------------------------------------------------------------------------------------------
export const CreateSeriesWrapper = styled.div`
  font-family: ${poppins.string};
  width: 840px;
  margin: auto;
  display:flex;
  flex-direction:column;
  align-items:center;
  background-color: #FFFFFF;
  border: 1px solid #0000001A;
  border-radius: 20px;
`;

export const TopicGenerationContainer = styled.div`
  width : 100%;
  padding-bottom:30px;
  font-size:14px;
  padding: 40px;
  box-sizing: border-box;
  
  .sourceTypeRow, .topicRow, .hashtagRow{
    display : grid;
    height : 64px;
    grid-template-columns: 5fr 19fr;
    padding: 0px 16px;
    box-sizing: border-box;

    .labelWrapper {
      display: flex;
      justify-content: flex-start; 
      align-items: center;
      color: #000000;
      padding: 0px 13px;
    }

    .valueWrapper {
      display: flex; 
      justify-content: center; 
      align-items: center;
      padding: 0px 13px;
      .ant-input {
        width: 100%;
        height: 36px;
      }
      .ant-select {
        width: 100%;
        height: 36px;
      }
    }
  }

   .sheetRow{
    display : grid;
    grid-template-columns: 5fr 19fr;
    padding: 0px 16px;
    box-sizing: border-box;

    .labelWrapper {
      display: flex;
      justify-content: flex-start; 
      padding-left : 10px;
      align-items: center;
      color: #000000;
      padding: 0px 13px;
    }

    .valueWrapper {
      display: flex; 
      justify-content: center; 
      align-items: center;
      padding: 0px 13px;
      .ant-input {
        width: 100%;
        height: 36px;
      }
      .inputBox {
        display:flex;
        justify-contents : center;
        align-items:center;
        width:100%;
        gap: 2px;
        .url {
          width: 100%;
        }

        border-bottom: solid;
        border-color: #F5F5F5;
        border-width: thin;
      }
    }
    .guideBox {
      display: flex;
      flex-direction: column;
      background-color: #F8F9FA;
      grid-column: 2;
      padding: 20px 20px 24px 20px;
      margin-top: 10px;
      border-radius: 4px;
      .guideBoxDefault {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-style: normal;
        line-height: 20px; 
        color: rgba(0, 0, 0, 0.80);
        .guideToggle{
          font-weight: 700;
        }
        .guideSample{
          color: #4276EE;
          font-size: 14px;
          font-weight: 600;
          text-decoration-line: underline;
        }
      }
    }
    .guideBoxContents {
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
      }
  } 
    
  .excelRow {
    height: 148px;
    border-radius:20px;
    background-color: #F8F9FA;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content : center;
    
    .excelWrapper {
      display:flex;
      flex-direction:column;
      align-items:center;
      width:100%;
      gap:16px;
      .uploadGuide {
        color:#000000CC;
      }

      .uploadButtonWrapper {
        display:flex;
        width:100%;
        justify-content: center;
        gap:10px;
        .excelDownloadButton {
          color: #4276EE;
          width:272px;
          height:44px;
          border-style:solid;
          border-width:thin;
          border-color: #4276EE;
          padding:10px;
          
        }
        .excelUploadButton {
          width:272px;
          height:44px;
          border-style:solid;
          border-width:thin;
          border-color: #4276EE;
          
        }
      }
    }

    .alertWrapper {
      display:flex;
      flex-direction:column;
      justify-content: space-between;
      align-items: start;
      gap: 14px;
      padding: 20px 0px;
      .ant-alert {
        width:600px;
        height:58px;
        padding: 10px 20px;
        background-color: #FFFFFF
      }
      .p-valid {
        color: #0FA958;
        size: 12px;
      }
      .p-invalid{
        color: #f41c1c;
        size: 12px;
      }
    }
  }

  .titleRow {
    font-size: 16px;
    font-weight: 600;
    color : #3075F6;
    display : flex;
    align-items : center;
    justify-content : flex-start;
  }
`;

const scheduleTitleRow = css`
  font-size:16px;
  font-weight: 600;
  color : #3075F6;
  display : flex;
  align-items : center;
  justify-content : flex-start;
`;

const editScheduleTitleRow = css`
  color: #000;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
export const ScheduleContainer = styled.div<{isEditing:boolean}>`
  width : 100%;
  padding-bottom:30px;
  font-size:14px;
  padding: 40px;
  padding-top: 0px;
  box-sizing: border-box;

  .scheduleRow, .setTimeRow, .setWeekdayRow, .setDateRow, .setEndDateRow, .isPausedRow, .noneRow{
    display : grid;
    height : 64px;
    width : 100%;
    grid-template-columns: 9fr 32fr;
    padding: 0px 16px;
    box-sizing: border-box;

    .labelWrapper {
      display: flex;
      justify-content: flex-start; 
      align-items: center;
      color: #000000;
      padding: 0px 13px;
    }

    .valueWrapper {
      width : 100%;
      display: flex; 
      justify-content: center; 
      align-items: center;
      padding: 0px 13px;
      .ant-radio-group {
        display: flex; 
        justify-content: flex-start;
        width: 100%;
        
        .ant-radio-wrapper {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-basis: 50%;
          span {
            font-size: small;
            gap:10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          span:not([class^="ant-radio"]) {
            flex: 1;
          }
        }
      }
    }

    .valueWrapper {
      display: flex; 
      justify-content: space-between; 
      align-items: center;
      background-color: #FFFFFF;
      padding: 0px 13px;

    }
  }

  .titleRow {
    ${({isEditing})=>(!isEditing ? scheduleTitleRow : editScheduleTitleRow)}
  }
    
  .scheduleRow, .setTimeRow, .setWeekdayRow, .setDateRow, .setEndDateRow, .isPausedRow, .noneRow {
    color: #000000;
    .labelWrapper {

    }

    .valueWrapper {
      .dayButtonWrapper {
        margin:5px;
        width:100%;
        display:flex;
        align-items:center;
        gap: 5px;
      }
    }
  }

  .noneRow {
    .noneScheduleGuide {
      grid-column: 2;
      width:100%;
    }
    padding: 0px 16px;
    box-sizing: border-box;
    color: rgba(0, 0, 0, 0.70);
    font-family: Inter;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
  }
`;

//SetOption Styles-------------------------------------------------------------------------------------------------------
export const SetOptionWrapper = styled.div`
  font-family: Inter;
  width: 840px;
  margin: auto;
  display:flex;
  flex-direction:column;
  align-items:center;
  background-color: #FFFFFF;
  padding: 40px 40px 50px 40px;
  border: 1px solid #0000001A;
  border-radius: 20px;

  .titleRow {
    width: 100%;
    color: #4276EE;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const OptionContainer = styled.div`
  width : 100%;
  font-size:14px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;

  .titleRow {
    color: #4276EE;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .optionRow1, .optionRow2 {
    display:grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 5px;
    width:100%;
    .duration, .language, .mediaSelect, .styleSelect{
      margin:8px;
      width:100%;
    }

    .durationSection, .languageSection, .mediaSection, .speedSection, .styleSection {
      display:grid;
      grid-template-columns: 5fr 14fr;

      .labelWrapper {
        display: flex;
        width: 100px;
        height: 64px;
        padding: 0px 16px;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        label{
          display: flex;
          width: 120px;
          padding: 13px 0px;
          align-items: center;
          gap: 2px;
          flex: 1 0 0;
          color: rgba(0, 0, 0, 0.80);
        }
      }

      .valueWrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 1 0 0;
        align-self: stretch;
        .ant-select {
          width: 100%;
          height: 36px;
        }
      }
    }
  }

  .styleRow {
    display:grid;
      grid-template-columns: 1fr 3fr;

      .labelWrapper {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background-color: #F8F9FA;
        color: #000000;
    }

    .valueWrapper {
        display: flex; 
        justify-content: center; 
        align-items: center;
        background-color: #FFFFFF;
      }
    }
  }
`;

export const ModelSelector = styled.div`
  width : 100%;
  font-weight: 500;
  line-height: 20px;
  width: 100%;
  .headerRow {
    width: 100%;
    display: flex;
    height: 44px;
    padding-top: 10px;
    padding-left: 16px;
    justify-content: space-between;
    align-items: center;
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter;
    font-style: normal;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
  }

  .ModelContainer {
    .body {
      margin-bottom: 20px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0;

      .button {
        cursor: pointer;
        width: 36px;
        height: 36px;
        top: -18px;
        z-index: 2;
      }

      .left {
        left: -15px;
      }

      .right {
        right: -15px;
      }

      .wrapper {
        max-width: 100%;
        transition: 1s;
        overflow: auto;
        display: flex;
        gap: 10px;

        display: block;
        white-space: nowrap;

        .selected {
          border: 2px solid #3075f6;
        }
      }
        .modelCard {
          position:relative;
          display:flex;
          flex-direction: column; 
          align-items: center; 
          justify-content: space-between;

          .modelAutoSelectContentWrapper {
            width:100%;
            height:100%;
            display:flex;
            flex-direction:column;
            justify-content:center;
            align-items:center;
          }
          .badge {
            position: absolute;
            display: block;
            width: auto;
            max-width: calc(100% - 10px);
            min-width: 46px;
            margin: 0;
            padding: 2px;
            font-size: 10px;
            line-height: 1.4;
            color: #fff;
            text-align: center;
            background-color: #363636;
            border-radius: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            z-index:999;
            &-custom {
              background-color: #108ee9;
            }
            &-sample {
              background-color: #363636;
            }
            &-auto {
              background-color: #E8E8E8;
            }
          }
        }
        .modelName {
          margin: 0;
          font-size: 11px;
          line-height: 2;
          color: #FFFFFF;
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          position: absolute; /* Position absolute */
          bottom: 0; /* Stick to bottom */
          left: 0; /* Stick to left */
          right: 0; /* Stick to right */
          padding: 2px; /* Optional padding */
          border-bottom-left-radius: 10px; /* Match the card's radius */
          border-bottom-right-radius: 10px; /* Match the card's radius */
        }

        .Image {
          width: 100%; /* Ensure the image fills the card's width */
          height: auto; /* Maintain aspect ratio */
        }
        
        .autoSelection {
          box-sizing: border-box;
          border-radius: 10px;
          overflow: hidden;
          cursor: pointer;
          width: 100px;
          height: 100px;
          margin-right: 10px;
          display: inline-block;
          outline-offset: -2px;
          background-color: #BEBEBE
        }
        .modelImageContainer {
          display: flex;
          justify-content: center;
          height:100px;
          width:100px;
          overflow:hidden;
          background-color: #000000;
          .portraitImage {
            height:160px;
            width:100px;
          }
          .landscapeImage {
            height:100px;
            width:160px;
          }
        }
        .portraitValue {
          box-sizing: border-box;
          border-radius: 10px;
          overflow: hidden;
          cursor: pointer;
          width: 100px;
          height: 100px;
          margin-right: 10px;
          display: inline-block;
          outline-offset: -2px;

          &:last-child {
            margin: 0;
          }
        }
        .landscapeValue {
          box-sizing: border-box;
          border-radius: 10px;
          overflow: hidden;
          cursor: pointer;
          width: 100px;
          height: 100px;
          margin-right: 10px;
          display: inline-block;
          outline-offset: -2px;
          &:last-child {
            margin: 0;
          }
        }
      }

      .no-scrollbars {
          -ms-overflow-style: none;
          scrollbar-width: none;
      
          &::-webkit-scrollbar {
            display: none;
          }
      }
    } 
  }
`;

export const TemplateSelector = styled.div`
  width : 100%;
  font-weight: 500;
  line-height: 20px;
  width: 100%;
  
  .headerRow {
    display: flex;
    width: 100%;
    height: 44px;
    padding-top: 10px;
    padding-left: 16px;
    justify-content: space-between;
    align-items: center;
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter;
    font-style: normal;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    .orientation {
      display: flex;
      align-items: center;
      gap: 10px;
      border: 1px solid #d9d9d9;
      border-radius: 25px;
      padding: 4px 20px;
      background: white;

      div {
        background: #dee3eb;
        border-radius: 2.5px;
        cursor: pointer;
      }

      .web {
        width: 20px;
        height: 15px;
      }

      .mobile {
        width: 15px;
        height: 20px;
      }

      .selected {
        border: 1px solid black;
      }
    }
  }

  .TemplateContainer {
    .body {
      margin-bottom: 20px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0;

      .button {
        cursor: pointer;
        width: 36px;
        height: 36px;
        top: -18px;
        z-index: 2;
      }

      .left {
        left: -15px;
      }

      .right {
        right: -15px;
      }

      .wrapper {
        max-width: 100%;
        transition: 1s;
        overflow: auto;
        display: flex;
        gap: 10px;

        .value {
          flex: 0 0 auto;
          box-sizing: border-box;
          border-radius: 10px;
          overflow: hidden;
          cursor: pointer;
          background-size: cover;
        }
        .landscape {
          height: 120px;
          width: 216px;
        }
        .portrait {
          width: 120px;
          height: 216px;
        }
        .selected {
          border: 2px solid #3075f6;
        }
      }
      .no-scrollbars {
          -ms-overflow-style: none;
          scrollbar-width: none;
      
          &::-webkit-scrollbar {
            display: none;
          }
      }

      .autoSelection {
        position:relative;
        flex: 0 0 auto;
        box-sizing: border-box; 
        border-radius: 10px; 
        overflow: hidden; 
        cursor: pointer; 
        width: 120px; 
        height: 100px; 
        background-size: cover;
        background-color: #BEBEBE;
        height: 214px;
        .modelAutoSelectContentWrapper{
          height:100%;
          width:100%;
          display:flex;
          justify-content:center;
          align-items:center;
        }

        .badge {
          position: absolute;
          display: block;
          width: auto;
          max-width: calc(100% - 10px);
          min-width: 46px;
          margin: 0;
          padding: 2px;
          font-size: 10px;
          line-height: 1.4;
          color: #fff;
          text-align: center;
          background-color: #363636;
          border-radius: 4px;
          overflow: hidden;
          text-overflow: ellipsis;
          z-index:999;
          &-auto {
            background-color: #E8E8E8;
          }
        }
      }
    }
  }
`;
export const DayButton = styled.button<{ selected: boolean }>`
    background-color: ${({ selected }) => (selected ? '#1890ff' : '#f0f0f0')};
    color: ${({ selected }) => (selected ? '#fff' : 'rgba(0, 0, 0, 0.5)')};
    border: none;
    border-radius: 4px;
    padding: 8px 8px;
    width: 100%;
    height: 100%;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    
    &:hover {
        background-color: ${({ selected }) => (selected ? '#40a9ff' : '#d9d9d9')};
    }
`;


//PostSetting Styles-------------------------------------------------------------------------------------------------------
export const PostSettingWrapper = styled.div`
  font-family: Inter;
  width: 840px;
  margin: auto;
  display:flex;
  flex-direction:column;
  align-items:center;
  background-color: #FFFFFF;
  padding: 40px 40px 50px 40px;
  border: 1px solid #0000001A;
  border-radius: 20px;
`;

export const AutoPostingContainer = styled.div`
  width : 100%;
  font-size:14px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  .titleRow {
    color: #4276EE;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .autoPostRow{
    display : grid;
    height : 5vh;
    min-height : 40px;
    max-height : 60px;
    grid-template-columns: 3fr 7fr;

    .labelWrapper {
      display: flex;
      height: 64px;
      padding: 0px 16px;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }

    .valueWrapper {
      display: flex; 
      justify-content: flex-start; 
      align-items: center;
      background-color: #FFFFFF;
      padding: 0px 13px;

      Button {
        margin: 10px;
      }

    }
  }
  .titleRow {
    display : flex;
    align-items : center;
    justify-content : flex-start;
  }
`;

export const SNSSettingContainer = styled.div`
  width : 100%;
  font-size:14px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  margin-top : 60px;
  .titleRow {
    color: #4276EE;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .platformSelectRow, .accountRow, .privacySelectRow{
    display : grid;
    grid-template-columns: 3fr 7fr;

    .labelWrapper {
      display: flex;
      width: 130px;
      height: 64px;
      padding: 0px 16px;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      flex-shrink: 0;
    }

    .valueWrapper {
      display: flex;
      height: 64px;
      padding: 0px 16px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 1 0 0;
      .platformSelection, .privacySelection, .tiktokConnected, .tiktokNotConnected {
        margin: 5px;
      }
      .ant-select {
        width: 100%;
        height: 36px;
      }
      .platformSelection {
        display: flex;
        gap: 20px;
        width: 100%;
        .custom-option {
          width: 48px;
          height: 48px;
          border-radius: 10px;  
          position: relative;
          border-radius: 8px;
          cursor: pointer;
          transition: background-color 0.3s;
          display: flex;
          justify-content: center; /* Center horizontally */
          align-items: center; 
        }

        .custom-option.selected {
          background: rgba(0, 0, 0, 0.05);
        }

        .tiktok-image {
          width: 28px;
          display: block;
          border-radius: 8px;
        }

        .shorts-image {
          width: 80px;
          display: block;
          border-radius: 8px;
        }

        .option-checkbox {
          position: absolute;
          bottom: 4px;
          right: 4px;
          width: 16px;
          height: 16px;
          border-radius: 3px;
          pointer-events: none;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .option-checkbox .checked {
          width: 12px;
          height: 12px;
          background-color: #1890ff; /* Ant Design primary color */
          border-radius: 2px;
        }
      }
    }

    .tiktokConnected {
      display:flex;
      justify-content: space-between;
      align-items:center;
      width:100%;
    }
    .tiktokNotConnected {
      display:flex;
      justify-content: space-between;
      align-items:center;
      width:100%;
      font-size:small;
      color: #000000
    }

    privacySelection {
      width:100%;
    }
  }
`;

export const TiktokAdvancedSettingContainer = styled.div`
  width : 100%;
  font-size:14px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  margin-top : 60px;
  .titleRow {
    color: #4276EE;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .tiktokConfigRow, .contentDisclosureRow, .brandConfigRow{
    display : grid;
    height : 5vh;
    min-height : 40px;
    max-height : 60px;
    grid-template-columns: 3fr 7fr;

    .labelWrapper {
      display: flex;
      height: 64px;
      padding: 0px 16px;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }

    .valueWrapper {
      display: flex;
      height: 64px;
      padding: 0px 16px;
      align-items: center;
      flex: 1 0 0;

      Button {
        margin: 10px;
      }

      .checkBoxes {
        width:100%;
        display:flex;
        justify-content: space-between;
      }

    }
  }

   .brandConfigRow {
    height : 5vh;
    min-height : 40px;
    max-height : 60px;
    background-color: #FFFFFF;  
    

    .valueWrapper {
      width:100%;
      grid-column: 2;
      display:flex;
      justify-content:center;
      align-items:center;
      .brandCheckBoxes{
        width:100%;
        display:flex;
        .checkBoxWrapper {
          width:50%;
        }
      }
    }
  }
`;